import { useFormAtom } from "@impero-com/common/utils/form/formAtom/hooks";
import { FormAtom } from "@impero-com/common/utils/form/formAtom/types";
import { extractNullable } from "@impero-com/common/utils/form/formAtom/validation";

import {
    RadioButtonGroupInput,
    RadioButtonGroupInputBaseProps,
    RadioButtonGroupInputValueType,
} from "../fields/radioButtonGroupInput";

export interface FARadioButtonGroupInputProps<
    T,
> extends RadioButtonGroupInputBaseProps<T> {
    atom: FormAtom<T>;
}

/**
 * Basic form component based on ant design's Radio.Group
 *
 * This component leverages the following constraints from the validator:
 *  - `.nullable()` is mapped to allowDeselect
 */
export const FARadioButtonGroupInput = <
    T extends RadioButtonGroupInputValueType,
>({
    atom,
    label,
    options,
    disabled,
    columns,
    direction,
}: FARadioButtonGroupInputProps<T>) => {
    const { value, error, dispatchValue } = useFormAtom(atom);

    const nullable = extractNullable(atom.schema);

    return (
        <RadioButtonGroupInput
            value={value}
            error={error?.value}
            onChange={(value) => void dispatchValue(value)}
            label={label}
            options={options}
            disabled={disabled}
            columns={columns}
            direction={direction}
            allowDeselect={nullable}
        />
    );
};
